/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';



const MyvehicleNumber = ({
  field: { name, value },
  form: { touched, errors, setFieldValue, values },
  blockVehicle,
  setvehicleInfo,
  setBatteryInfo,
  vehicleTypeField,
  ...props
}) => {

  const [vehicleNums, setvehicleNums] = useState([])
  const [loading, setloading] = useState(false)

  useEffect(() => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNumber: customerNo,
        userId: userId ,
        getAllRecords : props.getAllRecords ? true : false
      })
    // console.log(APP_CONSTANTS)
    setloading(true)
    Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster`, data, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {
      setvehicleNums(response.data.resultSet)
      setloading(false)

      let filteredVehicle = response.data.resultSet?.filter((object) => {
        return props.value === object.vehicleMasterId
      })
      console.log("filtered", filteredVehicle)
      // setFieldValue(vehicleTypeField, filteredVehicle[0].vehicleType)

    }))
      .catch(error => console.log(error))

  }, [props?.jobcardActivity])

  let vehicleOptions = []
  if (vehicleNums && vehicleNums.length > 0) {
    vehicleNums.map((object, index) => {
      let temp = {}
      temp.key = object.vehicleMasterId
      temp.text = object.vehicleNumber
      temp.value = object.vehicleMasterId
      return vehicleOptions[index] = temp
    })
  }

  const getVehicelInfo = (vehicleId) => {
    let data = JSON.stringify
      ({
        api_token: localStorage.getItem('apiToken'),
        customerNumber: localStorage.getItem('customerNo'),
        vehicleMasterId: vehicleId,
        userId: localStorage.getItem('userId')
      })

    Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster`, data, {
      headers: {
        'Accept': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        'Content-Type': 'application/json'
      }
    }).then((response => {
      let vehicleInfoArray = response.data.resultSet;

      setvehicleInfo(vehicleInfoArray);
      console.log("Vehicle Info Array", vehicleInfoArray)
      if (values.jobcardTypeName === "BATTERY") {
        getBatteryInfo(vehicleId)
      } else if (values.jobcardTypeName === "TYRE") {
        getTyreInfo(vehicleId, vehicleInfoArray[0].vehicleTypeMasterId)
      }
    }))
      .catch(error => console.log(error))
  }

  const getBatteryInfo = (vehicleId) => {

    let token = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleBatteryMapping?customerNumber=${customerNo}&userId=${userId}&vehicleId=${vehicleId}`, {
      headers: {
        'Accept': 'application/json',
        "Authorization": token,
        'Content-Type': 'application/json'
      }
    }).then((response => {
      let batteryInfoArray = response.data.resultSet
      setBatteryInfo(batteryInfoArray);
      setFieldValue("batteryDetails.oldSerialNumber", batteryInfoArray?.[0]?.batterySerialNo)
      setFieldValue("batteryDetails.oldBatteryMapId", batteryInfoArray?.[0]?.batteryMapId)
      setFieldValue("batteryDetails.installationDate", batteryInfoArray?.[0]?.batteryInstallationDate)
      setFieldValue("batteryDetails.checkboxSelect", false)
      setFieldValue("batteryDetails.flag", 0)


      console.log("Vehicle Info Array", batteryInfoArray)
    }))
      .catch(error => {
        console.log(error)
        setBatteryInfo([]);
        setFieldValue("batteryDetails.oldSerialNumber", '')
        setFieldValue("batteryDetails.oldBatteryMapId", '')
        setFieldValue("batteryDetails.installationDate", '')
        setFieldValue("batteryDetails.checkboxSelect", false)

      })
  }

  const getAllTyre = (vehicleMaster, existingTyre) => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleTypeTyrePositionMapping/?customerNumber=${customerNo}&userId=${userId}&vehicleTypeId=${vehicleMaster}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": token,
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then((response => {
        let allTyreSet = response.data.resultSet
        let tyreIDForExistingTyre = [];
        let newTyreSet = [];

        if (existingTyre.length > 0) {
          existingTyre.forEach(element => {
            tyreIDForExistingTyre.push(parseInt(element.tyrePositionId))
          });


          existingTyre.map((o, i) => {
            let filteredTyreInfo = {};
            filteredTyreInfo['tyreRun'] = o.tyreRun
            filteredTyreInfo['flag'] = 0
            filteredTyreInfo['tyreRunNew'] = ''
            filteredTyreInfo['tyrePositionId'] = o.tyrePositionId
            filteredTyreInfo['installationDate'] = o.installationDate
            filteredTyreInfo['oldTyreMapId'] = o.tyreMapId
            filteredTyreInfo['tyrePositionName'] = o.tyrepositionName
            filteredTyreInfo['oldSerialNo'] = o.serialNo;
            filteredTyreInfo['serialNo'] = ""
            filteredTyreInfo['checkboxSelect'] = false
            filteredTyreInfo['newInstallationDate'] = new Date()
            newTyreSet.push(filteredTyreInfo)
          })
        }


        allTyreSet.forEach(element => {
          if (!tyreIDForExistingTyre.includes(parseInt(element.positionId))) {
            let filteredTyreInfo = {};
            filteredTyreInfo['tyreRun'] = ""
            filteredTyreInfo['flag'] = 0
            filteredTyreInfo['tyreRunNew'] = ''
            filteredTyreInfo['tyrePositionId'] = element.positionId
            filteredTyreInfo['installationDate'] = "00-00-0000 00:00"
            filteredTyreInfo['oldTyreMapId'] = ''//element.vehicleTypeTyrePositionMapId
            filteredTyreInfo['tyrePositionName'] = element.tyrePosition
            filteredTyreInfo['oldSerialNo'] = null;
            filteredTyreInfo['serialNo'] = ""
            filteredTyreInfo['newSerialNo'] = ""
            filteredTyreInfo['checkboxSelect'] = false
            filteredTyreInfo['newInstallationDate'] = new Date()

            newTyreSet.push(filteredTyreInfo)
          }
        });
        setFieldValue('tyreDetailsFromAdd', newTyreSet)
      }))
      .catch(error => console.log(error))
  }

  const getTyreInfo = (vehicleId, vehicleMaster) => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleTyreMapping/?customerNumber=${customerNo}&userId=${userId}&vehicleId=${vehicleId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": token,
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {

      let tyresInfo = response.data.resultSet

      if (tyresInfo && tyresInfo.length > 0) {
        getAllTyre(vehicleMaster, response.data.resultSet)
        let filteredTyreInfo = [];
        let tyreRunValues = [];
        tyresInfo.map((o, i) => {
          filteredTyreInfo[i] = {};
          filteredTyreInfo[i]['tyreRun'] = o.tyreRun
          filteredTyreInfo[i]['flag'] = 0
          filteredTyreInfo[i]['tyreRunNew'] = ''
          filteredTyreInfo[i]['tyrePositionId'] = o.tyrePositionId
          filteredTyreInfo[i]['installationDate'] = o.installationDate
          filteredTyreInfo[i]['oldTyreMapId'] = o.tyreMapId
          filteredTyreInfo[i]['tyrePositionName'] = o.tyrepositionName
          filteredTyreInfo[i]['oldSerialNo'] = o.serialNo;
          filteredTyreInfo[i]['serialNo'] = ""
          filteredTyreInfo[i]['checkboxSelect'] = false
          filteredTyreInfo[i]['newInstallationDate'] = new Date()
          tyreRunValues.push(o.tyreRun)
        })

        setFieldValue('tyreDetails', filteredTyreInfo)
        setFieldValue('tyreRun', Math.max(...tyreRunValues))
      }
    }))
      .catch(error => {
        if (error?.response?.data?.resultSet) {
          let filteredTyreInfo = [];

          setFieldValue('tyreDetails', filteredTyreInfo)
          getAllTyre(vehicleMaster, {})
        }
        console.log(error)
      })
  }

  let handleFunctions = (e, data) => {

    data.options.forEach(element => {
      if (element.value == data.value) {
        if (props?.vehicleNoName) {
          setFieldValue(props.vehicleNoName, element.text)
        }
      }
    });

    setFieldValue(name, data.value)

    if (props.setVehicleSelected) {
      props.setVehicleSelected(data.value)
    }

    if (blockVehicle)
      blockVehicle(data.value)

    getVehicelInfo(data.value)

  }

  return (
    <Dropdown
      clearable
      selection
      placeholder="Vehicle No."
      search
      onChange={handleFunctions}
      options={vehicleOptions}
      {...props}
      loading={loading}
    />

  )
}

export default MyvehicleNumber